import { g as getClient } from './client-5dc6700c.esm.js';

function getLivepeerProvider() {
  var client = getClient();
  return client.provider;
}

function getStream(args) {
  var provider = getLivepeerProvider();
  return provider.getStream(args);
}

export { getStream as a, getLivepeerProvider as g };
